import React from 'react';
import '../styles/EducationBanner.css';
import { FaYoutube as FaYoutubeIcon, FaGraduationCap as FaGraduationCapIcon } from 'react-icons/fa';

/* Type Casting for Icons */
const FaYoutube = FaYoutubeIcon as any;
const FaGraduationCap = FaGraduationCapIcon as any;

const EducationBanner = () => {
    return (
        <div className="education-banner">
            <div className="container education-container">

                {/* Youtube Link */}
                <a
                    href="https://youtu.be/kyL2uF-BGZQ"
                    target="_blank"
                    rel="noreferrer"
                    className="edu-card edu-login"
                >
                    <div className="edu-icon">
                        <FaYoutube />
                    </div>
                    <div className="edu-text">
                        <h3>로그인 기기연결 설명</h3>
                        <p>처음 사용자를 위한 3분 가이드 영상</p>
                    </div>
                </a>

                {/* Course Link */}
                <a
                    href="https://www.gbedu.or.kr/gbsa/education/course/view.do?deGrCode=DE_000002307&menuNo=400032"
                    target="_blank"
                    rel="noreferrer"
                    className="edu-card edu-course"
                >
                    <div className="edu-icon">
                        <FaGraduationCap />
                    </div>
                    <div className="edu-text">
                        <h3>아두이노·IoT·빅데이터 서버 구축</h3>
                        <p>완전 정복 과정 - 무료 수강 신청하기</p>
                    </div>
                </a>

            </div>
        </div>
    );
};

export default EducationBanner;
